<template>
    <div>
        <h3>{{$t('intern_banner.title')}}</h3>
        <div v-html="$t('intern_banner.werbung_text')"></div>
        <div class="my-3">
            <div class="card p-3 my-3">
                <div class="row">
                    <div class="col-md-4">
                        <img :src="cdn + superbanner" class="card-img">
                    </div>
                    <div class="col-md-8 mt-3 mt-md-0">
                        <div class="card-body">
                            <h5 class="card-title mm-color font-15">{{$t('intern_banner.superbanner_titel')}}</h5>
                            <div class="font-12">
                                <p>
                                    {{$t('intern_banner.superbanner_anzeige')}} <br>
                                    <a href="/" class="mm-link">{{$t('intern_banner.werbeseite')}}</a>
                                </p>
                                <div v-html="$t('intern_banner.superbanner_preise')"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card p-3 my-3">
                <div class="row">
                    <div class="col-md-4">
                        <img :src="cdn + skyscraper" class="card-img">
                    </div>
                    <div class="col-md-8 mt-3 mt-md-0">
                        <div class="card-body">
                            <h5 class="card-title mm-color font-15">{{$t('intern_banner.skyscraper_titel')}}</h5>
                            <div class="font-12">
                                <p>
                                    {{$t('intern_banner.superbanner_anzeige')}} <br>
                                    <a href="/" class="mm-link">{{$t('intern_banner.werbeseite')}}</a>
                                </p>
                                <div v-html="$t('intern_banner.skyscraper_preise')"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card p-3 my-3">
                <div class="row">
                    <div class="col-md-4">
                        <img :src="cdn + contentad" class="card-img">
                    </div>
                    <div class="col-md-8 mt-3 mt-md-0">
                        <div class="card-body">
                            <h5 class="card-title mm-color font-15">{{$t('intern_banner.contentad_titel')}}</h5>
                            <div class="font-12">
                                <p>
                                    {{$t('intern_banner.superbanner_anzeige')}} <br>
                                    <a href="/" class="mm-link">{{$t('intern_banner.werbeseite')}}</a>
                                </p>
                                <div v-html="$t('intern_banner.contentad_preise')"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'banner',
        data() {
            return {
                cdn: '',
                skyscraper: '/images/zusatzoptionen/skyscraper.png',
                contentad: '/images/zusatzoptionen/content-ad.jpeg',
                superbanner: '/images/zusatzoptionen/superbanner.png',
            }
        },
        created() {
            document.title = 'Bannerwerbung'
            this.$http.get('/api/getCDN').then(response => {
                this.cdn = response.data;
            }).catch(error => {
                console.log(error);
            });
        }
    }
</script>

<style scoped>
.card-body{
    padding: 0.25rem;
}
</style>